<template>
    <div class="flex items-center justify-between my-2">
        <span class="flex flex-col flex-grow" id="toggleLabel">
            <span class="text-sm font-medium text-gray-900">{{ title }}</span>
            <slot/>
        </span>

        <button 
            type="button"  
            :aria-pressed="value" 
            aria-labelledby="toggleLabel" 
            @click="change"
            :class="value ? 'bg-green-600' : 'bg-gray-200'"
            class="relative inline-flex flex-shrink-0 h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
            
            <span class="sr-only">{{ title }}</span>
            <span 
                aria-hidden="true" 
                :class="value ? 'translate-x-5' : 'translate-x-0'"
                class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow ring-0"></span>
                
        </button>
    </div>
</template>

<script>
  export default {
    props: {
        title: {
            type: String,
            default: ""
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        checked: false
    }),
    methods: {
        change: function() {
            this.checked = this.value;
            this.checked = !this.checked;
            this.$emit('input', this.checked);

        }
       }
  }
</script>